// initial state
const state = {

   loaded:false,

   params:{
      loaded:false,
      lat:null,
      lng:null,
      zoom:null,
      pitch:null,
      bearing:null,
      style:'vector'
   },

   dimensions: null,
   dimensionsHover: null,

   poi:null,
   poiHover:null,
   poiActive:{
      featureId:null,
      styleLayer:null,
      sourceLayer:null,
      properties:null,
      geometry:null
   },
   // poi mode - if this is true, only allow user to interact with poi
   poiMode:false,

   labelHover:null,
   labelActive:{
      featureId:null,
      styleLayer:null,
      sourceLayer:null,
      properties:null,
      geometry:null
   },

   featureHighlight:null,
   featureHover:null,
   featureActive:{
      featureId:null,
      styleLayer:null,
      sourceLayer:null,
      properties:null,
      geometry:null
   },

   featureVisibleOn:null,
   featureVisibleOff:null,
   featureVisibleClear:null,

   featureQuery:null,
   featureQueryFound:null,

   controlLayers:[],

   layerGroupsVisible:['zoning'],

   bounds:null,
   leftMargin:null,
   //  move the map to a location based on bounds
   //  https://www.mapbox.com/mapbox-gl-js/api/#map#fitbounds
   fitBounds: {
      bounds: null,
      maxZoom: null,
      minZoom: null,
      padding: null,
   },
   fitBoundsDone:null,
   //  fly the map to the following parameters
   //  https://www.mapbox.com/mapbox-gl-js/api/#map#flyto
   flyTo: {
      //  point in format [lng, lat]
      center: null,
      zoom: null
   },
   flyToDone:null,

   //  set to change the zoom of the map
   zoomTo: null
};

// getters
const getters = {
   mapZoomGet:(state)=>()=>{
      return state.params.zoom;
   }
};

// actions
const actions = {

   // poi
   MAP_POI_SET:(context,data)=>{
      context.commit('MAP_POI_SET', data);
   },
   MAP_POI_HOVER_SET:(context,data)=>{
      context.commit('MAP_POI_HOVER_SET', data);
   },
   MAP_POI_ACTIVE_SET:(context,data)=>{
      context.commit('MAP_POI_ACTIVE_SET', data);
   },
   MAP_POI_MODE_SET:(context,data)=>{
      context.commit('MAP_POI_MODE_SET', data);
   },

   // dimensions
   MAP_DIMENSIONS_SET:(context,data)=>{
      context.commit('MAP_DIMENSIONS_SET', data);
   },
   MAP_DIMENSIONS_HOVER_SET:(context,data)=>{
      context.commit('MAP_DIMENSIONS_HOVER_SET', data);
   },

   // label
   MAP_LABEL_HOVER_SET:(context,data)=>{
      context.commit('MAP_LABEL_HOVER_SET', data);
   },
   MAP_LABEL_ACTIVE_SET:(context,data)=>{
      context.commit('MAP_LABEL_ACTIVE_SET', data);
   },

   // feature
   MAP_FEATURE_HIGHLIGHT_SET:(context,data)=>{
      context.commit('MAP_FEATURE_HIGHLIGHT_SET', data);
   },
   MAP_FEATURE_HOVER_SET:(context,data)=>{
      context.commit('MAP_FEATURE_HOVER_SET', data);
   },
   MAP_FEATURE_ACTIVE_SET:(context,data)=>{
      context.commit('MAP_FEATURE_ACTIVE_SET', data);
   },

   MAP_FEATURE_VISIBLE_ON:(context,data)=>{
      context.commit('MAP_FEATURE_VISIBLE_ON', data);
   },
   MAP_FEATURE_VISIBLE_OFF:(context,data)=>{
      context.commit('MAP_FEATURE_VISIBLE_OFF', data);
   },
   MAP_FEATURE_VISIBLE_CLEAR:(context,data)=>{
      context.commit('MAP_FEATURE_VISIBLE_CLEAR', data);
   },

   MAP_FEATURE_QUERY:(context,data)=>{
      context.commit('MAP_FEATURE_QUERY',data);
   },
   MAP_FEATURE_QUERY_FOUND:(context,data)=>{
      context.commit('MAP_FEATURE_QUERY_FOUND',data);
   },

   MAP_PARAMS_SET:(context,data)=>{
      context.commit('MAP_PARAMS_SET', data);
   },
   MAP_BOUNDS_SET:(context, data)=>{
      context.commit('MAP_BOUNDS_SET', data);
   },
   MAP_LEFT_MARGIN_SET:(context, data)=>{
      context.commit('MAP_LEFT_MARGIN_SET', data);
   },
  
   MAP_FIT_BOUNDS:(context, data)=>{
      context.commit('MAP_FIT_BOUNDS', data);
   },
   MAP_FIT_BOUNDS_DONE:(context, data)=>{
      context.commit('MAP_FIT_BOUNDS_DONE', data);
   },
   MAP_FLY_TO:(context, data)=>{
      context.commit('MAP_FLY_TO', data);
   },
   MAP_FLY_TO_DONE:(context, data)=>{
      context.commit('MAP_FLY_TO_DONE', true);
   },

   MAP_LAYER_GROUP_VISIBLE_OFF:(context, layerGroup)=>{
      context.commit('MAP_LAYER_GROUP_VISIBLE_OFF', layerGroup)
   },
   MAP_LAYER_GROUP_VISIBLE_ON:(context, layerGroup)=>{
      context.commit('MAP_LAYER_GROUP_VISIBLE_ON', layerGroup)
   },

   MAP_LOADED:(context, data)=>{
      context.commit('MAP_LOADED', data);
   },
   MAP_STYLE_SET:(context, data)=>{
      context.commit('MAP_STYLE_SET', data);
   },
   MAP_ZOOM:(context, data)=>{
      context.commit('MAP_ZOOM', data);
   }
};

// mutations
const mutations = {

   // poi
   MAP_POI_SET:(state, data)=>{
      state.poi = data;
   },
   MAP_POI_HOVER_SET:(state, data)=>{
      state.poiHover = data;
   },
   MAP_POI_ACTIVE_SET:(state, data)=>{
      state.poiActive = data;
   },
   MAP_POI_MODE_SET:(state, data)=>{
      state.poiMode = data;
   },

   // dimensions
   MAP_DIMENSIONS_SET:(state, data)=>{
      state.dimensions = data;
   },
   MAP_DIMENSIONS_HOVER_SET:(state, data)=>{
      state.dimensionsHover = data;
   },

   // label
   MAP_LABEL_HOVER_SET:(state, data)=>{
      state.labelHover = data;
   },
   MAP_LABEL_ACTIVE_SET:(state, data)=>{
      state.labelActive = data;
   },

   // feature
   MAP_FEATURE_HIGHLIGHT_SET:(state, data)=>{
      state.featureHighlight = data;
   },
   MAP_FEATURE_HOVER_SET:(state, data)=>{
      state.featureHover = data;
   },
   MAP_FEATURE_ACTIVE_SET:(state, data)=>{
      state.featureActive = data;
   },

   MAP_FEATURE_VISIBLE_ON:(state, data)=>{
      state.featureVisibleOn = data;
   },
   MAP_FEATURE_VISIBLE_OFF:(state, data)=>{
      state.featureVisibleOff = data;
   },
   MAP_FEATURE_VISIBLE_CLEAR:(state, data)=>{
      state.featureVisibleClear = data;
   },

   MAP_FEATURE_QUERY:(state, data)=>{
      state.featureQuery = data;
   },
   MAP_FEATURE_QUERY_FOUND:(state, data)=>{
      state.featureQueryFound = data;
   },

   MAP_PARAMS_SET:(state, params)=>{
      state.params = {...state.params, ...params};
   },
   MAP_BOUNDS_SET:(state, {bounds})=>{
      state.bounds = bounds;
   },
   MAP_LEFT_MARGIN_SET:(state, {leftMargin})=>{
      state.leftMargin = leftMargin;
   },

   MAP_FIT_BOUNDS: function(state, {bounds,maxZoom,minZoom,padding}){
      state.fitBoundsDone = false;
      state.fitBounds = {bounds,maxZoom,minZoom,padding};
   },
   MAP_FIT_BOUNDS_DONE: function(state, data){
      state.fitBoundsDone = true;
   },
   MAP_FLY_TO: function(state, {center, zoom}){
      state.flyToDone = false;
      state.flyTo = {center, zoom};
   },
   MAP_FLY_TO_DONE: function(state, data){
      state.flyToDone = true;
   },

   MAP_LAYER_GROUP_VISIBLE_ON: function(state, layerGroup){
      if (!state.layerGroupsVisible.includes(layerGroup)){
         state.layerGroupsVisible = [...state.layerGroupsVisible, layerGroup]
      }
   },
   MAP_LAYER_GROUP_VISIBLE_OFF: function(state, layerGroup){
      const layerGroupInd = state.layerGroupsVisible.indexOf(layerGroup)
      if (layerGroupInd !== -1){
         state.layerGroupsVisible = [...state.layerGroupsVisible.slice(0,layerGroupInd), ...state.layerGroupsVisible.slice(layerGroupInd+1)]
      }
   },

   MAP_LOADED: function(state, {}){
      state.loaded = true;
   },
   
   MAP_STYLE_SET: function(state, {style}){
      state.style = style;
   },
   MAP_ZOOM: function(state, {zoom}){
      state.zoomTo = zoom;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/map.js